import React from "react";
import { Link } from "react-router-dom";
import {
  Facebook,
  Linkedin,
  Youtube,
  Music2,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-[#0B0F19] border-t border-white/5 pt-20">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-[1px] bg-gradient-to-r from-transparent via-[#00BCF0]/50 to-transparent shadow-[0_0_20px_#00BCF0]" />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pb-16">
        <div className="space-y-6">
          <h2 className="text-2xl font-black uppercase italic tracking-tighter text-white">
            Connected <span className="text-[#00BCF0]">Group</span>
          </h2>
          <p className="text-[#A0AEC0] leading-relaxed">
            A combination of young, talented, and experienced experts dedicated
            to building the future of digital commerce.
          </p>
          <div className="flex gap-4">
            {[
              {
                icon: <Linkedin size={20} />,
                url: "https://www.linkedin.com/company/connectedbusinesssolutions/",
              },
              {
                icon: <Facebook size={20} />,
                url: "https://www.facebook.com/connectedbusinesssolution",
              },
              {
                icon: <Youtube size={20} />,
                url: "https://www.youtube.com/@Connected-Group-MM",
              },
              {
                icon: <Music2 size={20} />,
                url: "https://www.tiktok.com/@connectedgroup",
              },
            ].map((social, i) => (
              <a
                key={i}
                href={social.url}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white hover:bg-[#00BCF0] hover:border-[#00BCF0] transition-all duration-300">
                {social.icon}
              </a>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-white font-black uppercase tracking-widest text-sm mb-8">
            Navigation
          </h3>
          <ul className="space-y-4">
            {[
              { name: "Home", path: "/" },
              { name: "Services", path: "/services" },
              { name: "Products", path: "/products" },
            ].map((item) => (
              <li key={item.name}>
                <Link
                  to={item.path}
                  className="text-[#A0AEC0] hover:text-[#00BCF0] transition-colors flex items-center gap-2 group">
                  <span className="w-0 h-[2px] bg-[#00BCF0] group-hover:w-4 transition-all" />
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-white font-black uppercase tracking-widest text-sm mb-8">
            Company
          </h3>
          <ul className="space-y-4">
            {[
              "About Us",
              "Our Mission",
              "Our Vision",
              /* "Portfolio" */ /* "Blogs" */
            ].map((item) => (
              <li key={item}>
                <Link
                  to="/about"
                  className="text-[#A0AEC0] hover:text-[#00BCF0] transition-colors flex items-center gap-2 group">
                  <span className="w-0 h-[2px] bg-[#00BCF0] group-hover:w-4 transition-all" />
                  {item}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="space-y-6">
          <h3 className="text-white font-black uppercase tracking-widest text-sm mb-8">
            Contact
          </h3>
          <div className="space-y-4">
            <div className="flex items-start gap-4">
              <Phone size={18} className="text-[#00BCF0] shrink-0 mt-1" />
              <span className="text-[#A0AEC0]">(+95) 9 787 663799</span>
            </div>
            <div className="flex items-start gap-4">
              <Mail size={18} className="text-[#00BCF0] shrink-0 mt-1" />
              <span className="text-[#A0AEC0]">info@connected.com.mm</span>
            </div>
            <div className="flex items-start gap-4">
              <MapPin size={18} className="text-[#00BCF0] shrink-0 mt-1" />
              <span className="text-[#A0AEC0]">
                No(A9), 1st Floor, Shwe Kabar Housing, Mayangone Township,
                Yangon.
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5 bg-black/40 py-8">
        <div className="max-w-[1400px] mx-auto px-6 flex flex-col md:flex-row justify-center items-center gap-4">
          <p className="text-[#718096] text-sm">
            © {currentYear}{" "}
            <span className="text-white font-bold">Connected Group</span>. All
            rights reserved.
          </p>
          <div className="flex gap-6">
            <Link
              to="/privacy-policy"
              className="text-[#718096] text-sm hover:text-[#00BCF0] transition-colors">
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              className="text-[#718096] text-sm hover:text-[#00BCF0] transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
